<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <!-- <v-row>
        <v-col cols="12" md="4">
          <div class="d-flex">
            <v-checkbox class="mt-0 mr-6" label="Chính khóa" v-model="coreCurriculum" hide-details></v-checkbox>
            <v-checkbox class="mt-0" label="Bổ trợ" v-model="extraCurriculum" hide-details></v-checkbox>
          </div>
        </v-col>
      </v-row> -->
      <v-row>
        <v-col cols="12" sm="12" md="4">
          <AutocompleteAcademicLevel
            v-model="academicLevel"
            clear-icon="mdi-close"
            item-text="title"
            item-value="id"
            label="Bộ môn"
            clearable
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <AutocompleteDivision
            v-model="division"
            item-text="title"
            item-value="id"
            label="Chương trình đào tạo"
            dense
            outlined
            auto-select-first
            :hideDetails="true"
            :filter="{ academicLevel: get(academicLevel, 'id', '') }"
            :disabled="get(academicLevel, 'id', '').length < 1"
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteGrade
            return-object
            item-text="name"
            item-value="id"
            clear-icon="mdi-close"
            clearable
            label="Học phần"
            placeholder="Tất cả"
            outlined
            dense
            deletable-chips
            hide-details
            :filters="gradeFilter"
            @change="gradeChanged"
            :disabled="division.length < 1"
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteTeacherCard
            v-model="teacher"
            clearable
            clear-icon="mdi-close"
            outlined
            label="Giáo viên giảng dạy"
            dense
            deletable-chips
            hide-details
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="className"
            clear-icon="mdi-close"
            label="Tên lớp"
            flat
            outlined
            dense
            clearable
            hide-details
            @keyup.enter="onFilterChanged"
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import get from 'lodash-es/get'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import AutocompleteDivision from '@/components/basic/input/AutocompleteDivision'
import AutocompleteAcademicLevel from '../../components/basic/input/AutocompleteAcademicLevel.vue'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteTeacherCard,
    AutocompleteDivision,
    AutocompleteAcademicLevel
  },
  data: () => ({
    extraCurriculum: false,
    coreCurriculum: false,
    className: '',
    teacher: {},
    grade: {},
    division: '',
    academicLevel: {},
    get
  }),
  methods: {
    onFilterChanged() {
      let params = {
        grade: get(this.grade, 'id'),
        title_contains: this.className,
        headTeachers: get(this.teacher, 'id'),
        academicLevel: get(this.academicLevel, 'id'),
        division: this.division,
        _sort: 'createdAt:desc'
      }
      if (!((this.coreCurriculum && this.extraCurriculum) || (!this.coreCurriculum && !this.extraCurriculum))) {
        if (this.coreCurriculum) {
          params.type = 'coreCurriculum'
        } else if (this.extraCurriculum) {
          params.type = 'extraCurriculum'
        }
      }

      this.$emit('onFilterChanged', params)
    },
    gradeChanged(grade) {
      this.grade = grade
    }
  },
  computed: {
    gradeFilter() {
      return { division: this.division }
    }
  }
}
</script>

<style scoped></style>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
